import React from "react";
import DocumentDashboard from "./components/documentDashboard";
import DigitiseReport from "./components/digitiseReport";

class DigitisationModule extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      view: 0,
      props: null,
      dashboardKey: 0,
      dashboardKeyReload: 0,
      dashboardFilter: null,
    };
  }

  setView = (v, p, filter) => {
    this.setState((prev) => ({
      view: v,
      props: p,

      // save filter when leaving dashboard
      dashboardFilter: filter ?? prev.dashboardFilter,

      // remount dashboard when coming back
      dashboardKey: v === 0 ? prev.dashboardKey + 1 : prev.dashboardKey,
    }));
  };

  resetDashboard = () => {
    this.setState((prev) => ({ dashboardKey: prev.dashboardKey + 1 }));
  };
  render() {
    return (
      <>
        <div style={{ display: this.state.view === 0 ? "block" : "none" }}>
          <DocumentDashboard
            key={this.state.dashboardKey}
            setView={this.setView}
            data={this.state.props}
            history={this.props.history}
            dashboardKeyReload={this.state.dashboardKeyReload}
            dashboardFilter={this.state.dashboardFilter}
          />
        </div>
        {this.state.view === 1 ? (
          <DigitiseReport
            setView={this.setView}
            data={this.state.props}
            resetDashboard={this.resetDashboard}
          />
        ) : (
          <></>
        )}
      </>
    );
  }
}

export default DigitisationModule;
